const rolesAndNames = {
  administrator: 'Administrador',
  systemAdministrator: 'Administrador do Sistema',
  appSebrae: 'App SEBRAE',
  uge: 'UGE',
  manager: 'Gestor Nacional',
  stateManager: 'Gestor Estadual',
  agent: 'Agente',
  appSebraeManager: 'Gestor App SEBRAE',
  appSebraeStateManager: 'Gestor Estadual do SEBRAE na sua empresa',
  appSebraeNationalManager: 'Gestor Nacional do SEBRAE na sua empresa',
}

export type Role = keyof typeof rolesAndNames
export const roles = Object.keys(rolesAndNames) as Role[]
export default rolesAndNames
